// src/modules/operaciones/inventarios/components/TablaTraslados.js
//
// Tabla de traslados pendientes: cabeceras ordenables, skeleton de carga, estado vacío y filas.
import React from 'react';
import { fechaDe } from '../utils/trasladosComun';

const COLUMNAS = [
  { campo: 'PREFIJO', label: 'Prefijo', align: '' },
  { campo: 'NUMERO', label: 'Número', align: '' },
  { campo: 'FECHA', label: 'Fecha', align: '' },
  { campo: 'CONCEPTO', label: 'Concepto', align: '' },
  { campo: 'REFERENCIA', label: 'Referencia', align: '' },
  { campo: 'ORIGEN', label: 'Origen', align: 'text-center' },
  { campo: 'DESTINO', label: 'Destino', align: 'text-center' },
];

// Tabla de la página actual (extraída del render de InventariosTraslados.js sin cambios de markup)
export default function TablaTraslados({ tema, loading, orden, alternarOrden, trasladosPaginados, hayFiltros, limpiarFiltros, indiceInicial }) {
  return (
    <div className={`${tema.bgCard} rounded-2xl border ${tema.borderMain} shadow-xl overflow-hidden flex-1 flex flex-col transition-colors duration-300`}>
      <div className="overflow-x-auto">
        <table className={`w-full text-left text-sm ${tema.textSub} whitespace-nowrap`} aria-busy={loading}>
          <thead className={`${tema.bgHeader} ${tema.textSub} text-xs uppercase tracking-wider border-b ${tema.borderMain}`}>
            <tr>
              <th className="px-6 py-4 font-bold">#</th>
              {COLUMNAS.map((c) => {
                const activo = orden.campo === c.campo;
                return (
                  <th key={c.campo} className={`px-6 py-4 font-bold ${c.align}`} aria-sort={activo ? (orden.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
                    <button type="button" onClick={() => alternarOrden(c.campo)} className="inline-flex items-center gap-1 uppercase tracking-wider font-bold hover:opacity-80 cursor-pointer">
                      {c.label}<span className="text-[10px] opacity-70">{!activo ? '↕' : orden.dir === 'asc' ? '▲' : '▼'}</span>
                    </button>
                  </th>
                );
              })}
              <th className="px-6 py-4 font-bold text-center">Estado</th>
            </tr>
          </thead>
          <tbody className={`divide-y ${tema.borderMain}`}>
            {loading ? (
              [0, 1, 2].map((i) => (
                <tr key={i} className="animate-pulse">
                  <td colSpan="9" className="px-6 py-4"><div className={`h-6 rounded-lg ${tema.bgSkeleton}`} /></td>
                </tr>
              ))
            ) : trasladosPaginados.length === 0 ? (
              <tr>
                <td colSpan="9" className="px-6 py-12 text-center text-gray-500">
                  <p>No se encontraron traslados con los filtros actuales.</p>
                  {hayFiltros && (
                    <button
                      onClick={limpiarFiltros}
                      className="mt-4 px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold transition-colors cursor-pointer"
                    >
                      Limpiar filtros
                    </button>
                  )}
                </td>
              </tr>
            ) : (
              trasladosPaginados.map((t, index) => (
                <tr key={`${t.PREFIJO}-${t.NUMERO}`} className={`${tema.bgHover} transition-colors`}>
                  <td className="px-6 py-4 text-gray-500 font-mono text-xs">{indiceInicial + index + 1}</td>
                  <td className={`px-6 py-4 font-bold ${tema.textMain}`}>{t.PREFIJO}</td>
                  <td className="px-6 py-4 font-mono text-blue-500 font-bold">{t.NUMERO}</td>
                  <td className="px-6 py-4">{fechaDe(t)}</td>
                  <td className="px-6 py-4 max-w-[250px] truncate" title={t.CONCEPTO}>{t.CONCEPTO}</td>
                  <td className="px-6 py-4 text-gray-500">{t.REFERENCIA || '-'}</td>
                  {[[t.ORIGEN, tema.badgeOrigen], [t.DESTINO, tema.badgeDestino]].map(([bodega, clase], i) => (
                    <td key={i} className="px-6 py-4 text-center">
                      <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full border font-bold text-xs ${clase}`}>{bodega || '-'}</span>
                    </td>
                  ))}
                  <td className="px-6 py-4 text-center">
                    <span className={`px-3 py-1 rounded-full text-[10px] font-extrabold border ${tema.badgePendiente}`}>
                      Pendiente
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}